<template>
<div id="top2">
    <div class="cc-header">
        <img src="../../assets/img/icon1.png" class="img" />
        <div>当日预警信息</div>
    </div>
    <div class="d-flex jc-center">
        <dv-scroll-board :config="config" class="rankChart" />
    </div>
</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
export default {
    data() {
        return {
            config: {}
        };
    },
    mounted() {
        this.initData();
        // 定时器刷新，10秒
        let _this = this;
        setInterval(() => {
            _this.initData(); // 修改数据date
        }, 10000);
    },
    methods: {
        initData() {
            let _this = this;
            this.$http.get("/dataView/temp/getHighTempUser?orgCode=" + orgCode).then(res => {
                if (res.data.code === 200) {
                    var result = res.data.result;
                    var data = [];
                    for (var i = 0; i < result.length; i++) {
                        var orgName = result[i].orgName;
                        var cosType = result[i].cosType;
                        var cosPath = result[i].cosPath;
                        var dataList = result[i].dataList;
                        for (var j = 0; j < dataList.length; j++) {
                            //判断该机构是本地存储还是cos存储 0：cos  1：本地
                            var param;
                            var className;
                            var style;
                            if (orgName.length > 12) {
                                className = "info3";
                                style = "line-height: 0.3rem;";
                            } else if (orgName.length > 6 && orgName.length <= 12) {
                                className = "info2";
                                style = "line-height: 0.4rem;";
                            } else {
                                className = "info1";
                                style = "line-height: 0.6rem;";
                            }
                            if (cosType == '0') {
                                param = [
                                    '<div class="picBox"><img src="' + cosPath + dataList[j].photo + '" alt="" class="pic" /></div>',
                                    '<div class="' + className + '"><label>姓名：</label>' + dataList[j].name + '</div>' +
                                    '<div class="' + className + '" style="' + style + '"><label>学校：</label><span class="schoolName">' + orgName + '</span></div>' +
                                    '<div class="' + className + '"><label>身份：</label>' + dataList[j].type + '</div>' +
                                    '<div class="' + className + '"><label>温度：</label><span class="temp">' + dataList[j].temp + '°C</span></div>'
                                ];
                            } else {
                                param = [
                                    '<div class="picBox"><img src="' + this.$baseURL + dataList[j].photo + '" alt="" class="pic" /></div>',
                                    '<div class="' + className + '"><label>姓名：</label>' + dataList[j].name + '</div>' +
                                    '<div class="' + className + '" style="' + style + '"><label>学校：</label><span class="schoolName">' + orgName + '</span></div>' +
                                    '<div class="' + className + '"><label>身份：</label>' + dataList[j].type + '</div>' +
                                    '<div class="' + className + '"><label>温度：</label><span class="temp">' + dataList[j].temp + '°C</span></div>'
                                ];
                            }
                            data.push(param);
                        }
                    }

                    var config = {
                        data: data,
                        rowNum: 2,
                        waitTime: 2000,
                        headerBGC: '#ffffff00',
                        oddRowBGC: '#ffffff00',
                        evenRowBGC: '#ffffff00',
                        carousel: 'single',
                        align: ['center', 'center']
                    };
                    _this.config = config;
                }
            });
        }
    }
};
</script>

<style lang="scss">
#top2 {
    height: 6.4rem;

    .cc-header {
        height: 1rem;
        color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;

        .img {
            width: 0.4rem;
            margin-right: 0.1rem;
        }
    }

    .rankChart {
        height: 5.25rem;
        width: 4.5rem;

        .picBox {
            width: 96%;
            height: 90%;
            border: 2px solid #520500;
            padding: 0.05rem;
            border-radius: 5px;

            .pic {
                width: 100%;
                height: 100%;
            }
        }

        .info1 {
            height: auto;
            line-height: 0.5rem;
            font-size: 0.2rem;
        }

        .info2 {
            height: auto;
            line-height: 0.5rem;
            font-size: 0.2rem;
        }

        .info3 {
            height: auto;
            line-height: 0.5rem;
            font-size: 0.2rem;
        }

        label {
            float: left;
        }

        .temp {
            color: #f00;
        }

        .schoolName {
            white-space: break-spaces;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }
    }
}
</style>
